import { render, staticRenderFns } from "./ExpandableTable.vue?vue&type=template&id=a8126b1a&scoped=true&"
import script from "./ExpandableTable.vue?vue&type=script&lang=js&"
export * from "./ExpandableTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableTable.vue?vue&type=style&index=0&id=a8126b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8126b1a",
  null
  
)

export default component.exports